export const headerInfoSelector = state => state.headerInfo;